<div class="sg-flex-column sg-borrower-input-container">
  <mat-form-field appearance="outline" class="slim-form-field sg-short-input" [hideRequiredMarker]="true" subscriptSizing="dynamic">
    <input
      data-test="borrower-input"
      matInput
      data-hj-allow
      autocomplete="off"
      mask="separator.{{numberOfDecimalPoints}}"
      thousandSeparator=","
      suffix="{{ inputSuffix ?? '' }}"
      [allowNegativeNumbers]="allowNegativeNumbers"
      [formControl]="withFormControl"
      (click)="clearInput()"
      (blur)="onBlur($event)"
      [errorStateMatcher]="getErrorMatcher()" />
    @if (formFieldSuffix) {
    <sg-text matSuffix variant="sg-p1-small-letters" class="borrower-field-suffix">{{ formFieldSuffix }}</sg-text>
    } @if (withFormControl.enabled && showRevertButton$ | async) {
    <button
      class="sg-reveret-button"
      mat-icon-button
      [sgTooltip]="revertTooltipMsg ? revertTooltipMsg : 'Revert'"
      tooltipPosition="above"
      (mousedown)="revertValue()"
      data-test="borrower-input-revert-button">
      <mat-icon matSuffix>rotate_left</mat-icon>
    </button>
    }
  </mat-form-field>
  @if (!(isSelected$ | async) && withFormControl.invalid) {
  <div data-test="borrower-input-warning" class="enter-units-warning">
    <mat-icon matSuffix color="warn">warning</mat-icon>
    {{ withFormControl | sgErrorMessage: errorValidatorsMessages }}
  </div>
  }
</div>
